import unionBy from 'lodash/unionBy';

const zendesk = (state = {}, action) => {
  switch (action.type) {
    case 'ZENDESK_CURRENT_PAGE':
      return Object.assign({}, state, {
        currentPage: action.currentPage,
        selectedArticle: action.selectedArticle,
      });
    case 'ZENDESK_CATEGORIES':
      return Object.assign({}, state, {
        categories: action.categories,
      });
    case 'ZENDESK_SECTIONS':
      return Object.assign({}, state, {
        sections: action.sections,
      });
    case 'ZENDESK_ARTICLES':
      const existingArticles = Object.assign([], state.articles);
      const newArticles = unionBy(existingArticles, action.articles, (article) => article.id);

      return Object.assign({}, state, {
        articles: newArticles,
      });
    case 'ZENDESK_ARTICLE_SEARCH':
      return Object.assign({}, state, {
        articleSearchResults: action.articles,
        currentPage: 'searchResults',
      });
    case 'ZENDESK_USER':
      const users = Object.assign({}, state.users);
      users[action.user.id] = action.user;

      return Object.assign({}, state, {
        users: users,
      });
    case 'HYDRATE_ZENDESK_REFUND_DROPDOWN':
      return Object.assign({}, state, { refundDropdown: action.data });
    case 'HYPDRATE_ZENDESK_CANCEL_DROPDOWN':
      return Object.assign({}, state, { cancelDropdown: action.data });
    case 'ZENDESK_CLEAR':
      return {
        currentPage: '',
        categories: [],
        sections: [],
        articles: [],
        users: {},
        articleSearchResults: [],
        selectedArticle: null,
        refundDropdown: [],
        cancelDropdown: [],
      };
    default:
      return state;
  }
};

export default zendesk;
